import { NgPlural, NgPluralCase } from '@angular/common';
import {Component, inject, OnInit} from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { version } from '../../package.json';
import { PreviewService } from './core/services/preview.service';
import { ScrollService } from './shared/services/scroll.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgPlural, NgPluralCase],
  template: '<router-outlet />',
  host: {
    class: 'contents'
  }
})
export class AppComponent implements OnInit{
  readonly #scrollService = inject(ScrollService);
  readonly #previewService = inject(PreviewService);
  router = inject(Router);

  private defaultLang = 'he';
  private prevLang: string | null = null;

  ngOnInit(): void {
    console.log('Version ' + version);

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        const navEnd = event as NavigationEnd;
        const html = document.documentElement;

        if (navEnd.urlAfterRedirects.startsWith('/en/')) {
          this.prevLang = html.getAttribute('lang');
          html.setAttribute('lang', 'en');
        } else {
          html.setAttribute('lang', this.prevLang || this.defaultLang);
        }
      });

    this.#scrollService.routeScrollToTop();
    this.#previewService.initPreview();
  }
}
